import styled from 'styled-components';

export const AgentInfoContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 30px;
`;

export const AgentInfoContent = styled.div`
  width: 100%;
  height: 50%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: 40% 60%;
  grid-template-rows: 100%;
  column-gap: 40px;
  align-items: center;
`;

export const AgentImage = styled.div`
  width: 260px;
  height: 450px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255, 255, 255);
  position: relative;

  img {
    max-height: 100%;
    width: auto;
    min-width: 100%;
    object-fit: cover;
    object-position: center;
    transform: scale(1);
    transform-origin: center center;
  }

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const AgentContentRight = styled.div`
  grid-column: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
`;

export const AgentData = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const AgentName = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 40px;
  font-weight: 500;
  color: #0077b6;
`;

export const SecondaryInfo = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #212632;
`;

export const Description = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #747d93;
`;
